import { AttributeDefinitionDto } from "../../../../../common/apis/stereotype/AttributeDefinitionDto";
import {
    ConstraintValueValidationPluginRegistry
} from "../../datatype/constraint/ConstraintValueValidationPluginRegistry";
import {TranslationFunction} from "../../../../../store/localization/TranslMessasge";
import {CommonTranslationKey} from "../../CommonTranslationKey";
import {ConstraintValueValidationPlugin} from "../../datatype/constraint/ConstraintValueValidationPlugin";
import {DataTypeDefinitionDto} from "../../../../../common/apis/datatype/DataTypeDefinitionDto";
import {DataTypeConstraintDto} from "../../../../../common/apis/datatype/DataTypeConstraintDto";
import {CoreDataTypeValidator} from "../../datatype/CoreDataTypeValidator";

interface ValidationContext {
    plugin: ConstraintValueValidationPlugin;
    constraint: DataTypeConstraintDto;
}


export class AttributeValueValidator {

    private coreDataTypeValidator = new CoreDataTypeValidator();

    validateValue(value: string | null | undefined, attributeDefinition: AttributeDefinitionDto, t: TranslationFunction): Record<string, string> {
        if (value === undefined || value === null) {
            if (attributeDefinition.required) {
                return {
                    [attributeDefinition.id]: t(CommonTranslationKey.FILL_OUT_THIS_FIELD)
                };
            } else {
                return {};
            }
        }

        const error = this.coreDataTypeValidator.validateValue(value, attributeDefinition.dataType.coreDataType, t);
        if (error) {
            return {
                [attributeDefinition.id]: error
            };
        }

        const plugins = this.findValidationContexts(attributeDefinition.dataType);
        return plugins.map(ctx => ctx.plugin.validateValue(value, attributeDefinition.id, ctx.constraint, t))
                .reduce((a, b) => Object.assign(a, b), {});
    }

    private findValidationContexts(dataTypeDefinition: DataTypeDefinitionDto): ValidationContext[] {
        const constraints = dataTypeDefinition.constraints ?? [];
        return constraints.map(constraint => {
            const plugin = ConstraintValueValidationPluginRegistry.getPlugin(constraint.constraintData.type);
            if (!plugin) {
                throw new Error("Unsupported constraint type: " + constraint.constraintData.type);
            }
            return {
                plugin: plugin,
                constraint: constraint
            };
        });
    }
}